<span class="kody-chip" [ngClass]="size" [class.kody-chip--unavailable]="unavailable">
  <ion-chip [color]="color"><ng-content></ng-content></ion-chip>
</span>
